import { Compass, Flame } from "lucide-react";

// Day One = Discovery (curiosity), Day Two = Thanksgiving (gratitude)
const DAYS = [
  {
    id: "day-one",
    title: "The Genesis One",
    subtitle: "Discovery",
    date: "Wed 19 August 2026",
    accent: "#1B4F72",
    icon: Compass,
    steps: [
      ["15:00", "Gates open · opening procession to the harbour"],
      ["16:30", "Discovery showcase · new artists & emerging chefs"],
      ["19:00", "Sundown picnic tables under the pines"],
      ["21:30", "Lantern-lit acoustic set"],
      ["23:00", "Last ferry · slow walk back through the meadow"],
    ],
  },
  {
    id: "day-two",
    title: "The Genesis Two",
    subtitle: "Thanksgiving",
    date: "Thu 20 August 2026",
    accent: "#C89B5C",
    icon: Flame,
    steps: [
      ["13:00", "Gates open · gratitude bell at the lawn"],
      ["15:00", "Long-table thanksgiving feast"],
      ["19:00", "Sundown champagne toast to the summer past"],
      ["21:00", "Headline closing performance under the stars"],
      ["Late", "Bonfire & dawn farewell by the water"],
    ],
  },
];

function DayCard({ day }) {
  const Icon = day.icon;
  return (
    <article
      className="rounded-2xl text-cream p-7 md:p-8 shadow-soft relative overflow-hidden"
      style={{ backgroundColor: day.accent }}
      data-testid={`flow-card-${day.id}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-cream/15 flex items-center justify-center">
          <Icon size={18} />
        </div>
        <div>
          <p className="text-[10px] font-bold tracking-[0.22em] uppercase text-cream/80">
            {day.date}
          </p>
          <p className="font-serif text-2xl md:text-3xl">
            {day.title}
            <span className="italic-accent ml-2 text-cream/85">
              {day.subtitle}
            </span>
          </p>
        </div>
      </div>

      <ol className="mt-6 relative">
        <span
          className="absolute left-[18px] top-2 bottom-2 w-px bg-cream/25"
          aria-hidden
        />
        {day.steps.map(([time, copy]) => (
          <li key={time + copy} className="relative pl-10 py-2.5">
            <span
              className="absolute left-[12px] top-3.5 w-3 h-3 rounded-full bg-cream/90 ring-2 ring-cream/30"
              aria-hidden
            />
            <span className="block text-[11px] font-bold tracking-widest uppercase text-cream/70">
              {time}
            </span>
            <span className="block text-sm leading-snug text-cream/95">
              {copy}
            </span>
          </li>
        ))}
      </ol>
    </article>
  );
}

export default function DaysFlow() {
  return (
    <section
      className="container-x py-16 md:py-24"
      data-testid="days-flow-section"
    >
      <p className="eyebrow">How the days flow</p>
      <h2 className="heading-xl mt-2">From discovery</h2>
      <h2 className="font-serif italic text-coral text-4xl md:text-6xl leading-tight">
        to thanksgiving.
      </h2>
      <p className="body-lead mt-3 max-w-2xl">
        Two days. One arc. The Genesis opens curious and closes grateful — here&apos;s
        what each day brings, from gate to bonfire.
      </p>
      <div className="mt-10 grid md:grid-cols-2 gap-5 md:gap-6">
        {DAYS.map((d) => (
          <DayCard key={d.id} day={d} />
        ))}
      </div>
    </section>
  );
}
